import type { Languages } from '@onevesthq/ov-enums';
import type { Account } from './account';
import type { NotificationGroup } from './notificationGroup';
import type { AuthenticationConnections, Organization } from './organization';
import type { RepCode } from './repCode';
import type { Role } from './role';
import type { User } from './user';

export enum AuthAudienceTypes {
  CLIENT = 'CLIENT',
  ONEHUB = 'ONEHUB',
}

export enum OrganizationUserAccessTypes {
  ORGANIZATION = 'ORGANIZATION',
  ENTITY = 'ENTITY',
  REP_CODE = 'REP_CODE',
}

export enum OrganizationUserEntityRelationTypes {
  ADVISOR = 'ADVISOR',
  OTHER = 'OTHER',
  OWNER = 'OWNER',
  POWER_OF_ATTORNEY = 'POWER_OF_ATTORNEY',
}

export enum OrganizationUserLoginStatus {
  LOGGED_IN = 'LOGGED_IN',
  NOT_LOGGED_IN = 'NOT_LOGGED_IN',
  INVITED = 'INVITED',
  INVITATION_EXPIRED = 'INVITATION_EXPIRED',
  NOT_INVITED = 'NOT_INVITED',
}

export type OrganizationUserEntity = {
  entity?: User;
  readOnly?: boolean;
  relation?: OrganizationUserEntityRelationTypes;
  role?: Role;
  accounts?: Account[];
};

export type OrganizationUserRepCodeEntity = {
  entity?: User;
  repCodes?: RepCode[];
};

export type NotificationPreference = {
  enableInApp?: boolean;
  enablePush?: boolean;
  enableEmail?: boolean;
};

export type UserNotificationPreference = {
  notificationGroup: NotificationGroup;
  preferences?: NotificationPreference;
};

export type OrganizationUser = {
  id?: string;
  organization?: Organization;
  firstName?: string;
  lastName?: string;
  email?: string;
  phone?: string;
  avatar?: string;
  language?: Languages;
  authAudience?: AuthAudienceTypes;
  role?: Role;
  auth0invitationId?: string;
  auth0invitationExpiresAt?: Date;
  authConnectionType?: AuthenticationConnections;
  accessType?: OrganizationUserAccessTypes;
  entities?: OrganizationUserEntity[];
  referenceId?: string;
  lastLoggedInAt?: Date;
  mfaEnrollmentId?: string;
  notificationPreferences?: UserNotificationPreference[];
  repCodes?: RepCode[];
  repCodeEntities?: OrganizationUserRepCodeEntity[];
  loginStatus?: OrganizationUserLoginStatus;
  viewFullClientGroup?: boolean;
};

export const getOrganizationUserName = (
  organizationUser?: OrganizationUser,
): string =>
  `${organizationUser?.firstName || ''} ${organizationUser?.lastName || ''}`.trimEnd();
